import React from 'react';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

class FormTraducoesSubLista extends React.Component {                
    render() {        
        return (                                           
            this.props.cadastros.length?this.props.cadastros.map(itens => {
                if(itens.identificador !== this.props.identificador){
                    return null
                }
                if(itens.extra.length){
                    itens = {
                        ...itens.extra[0]
                    }
                }
                return (
                    <tr key={itens.idtraducao}>
                        <td className="text-break">
                            {itens.portugues}
                        </td>
                        <td className="text-break">
                            {itens.ingles}
                        </td>
                        <td className="text-break">
                            {itens.espanhol}
                        </td>
                        <td className="text-center">
                            <CommentEdit style={{cursor: "pointer"}} onClick={() => this.props.handleEditar(this.props.form, itens)} size="35" />
                        </td>
                    </tr>  
                )
            })
            :
            null
        );
    }
}

export default FormTraducoesSubLista;